<template>
  <li class="sliderTag">
    <slot />
  </li>
</template>
<script>
export default {
  
}
</script>